// extracted by mini-css-extract-plugin
export default {"headerTitle":"SearchHeaderContainer-module__headerTitle___2INF3"};